import React from 'react';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { useFetch } from '../../../../hooks';
import { renderData } from '../../../../helpers';
import { getDataByKey } from '../../../../helpers';
import Container from '../../../../components/Container';
import HeadBar from '../../../../modules/HeadBar';
import SearchTag from '../../../../modules/SearchTag';
import PageLoader from '../../../../components/PageLoader'
import { StyledScannerAddTag, StyledScannerAddTagWrapper } from './styled';

const ScannerAddTag = () => {
    const history = useHistory();

    const { response, error, fetching } = useFetch({
        url: '/tag_search',
        method: 'GET'
    });

    const { doFetch: addTag } = useFetch({
        url: '/rpc/tf_add_tag',
        method: 'POST'
    });

    const renderDataState = renderData({ data: response, error, fetching });

    const handleClickTag = tagid => async () => {
        try {
            const res = await addTag({ data: { tagid } });
            if (res > 0) {
                history.replace('/manage/scanner');
            } else {
                const translation = getDataByKey(response, 'labels', {});
                toast.error(translation && translation.error)
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <StyledScannerAddTag>
            <HeadBar
                title={getDataByKey(response, 'title', '')}
                backTo="/manage/scanner"
            />
            <StyledScannerAddTagWrapper>
                <Container>
                    {
                        renderDataState({
                            fetching: () => (<PageLoader />),
                            error: error => (<div>{error.toString()}</div>),
                            data: data => (
                                <SearchTag
                                    data={getDataByKey(data, 'data', [])}
                                    onClickTag={handleClickTag}
                                    translation={{
                                        labels: getDataByKey(data, 'labels', {}),
                                        buttons: getDataByKey(data, 'buttons', {}),
                                    }}
                                />
                            )
                        })
                    }
                </Container>
            </StyledScannerAddTagWrapper>
        </StyledScannerAddTag>
    );
}

export default ScannerAddTag;